/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Email',
    field_name: 'learner_email',
    source_field: 'learner_email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'First Name',
    field_name: 'learner_first_name',
    source_field: 'learner_first_name',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Last Name',
    field_name: 'learner_last_name',
    source_field: 'learner_last_name',
    showColumn: true,
  },
  {
    id: 4,
    label: 'Group name',
    field_name: 'learner_current_group_name',
    source_field: 'learner_current_group_name',
    showColumn: true,
  },
  {
    id: 5,
    label: 'Class start time',
    field_name: 'class_start_time',
    source_field: 'class_start_time',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Length of class',
    field_name: 'length_of_class',
    source_field: 'length_of_class',
    showColumn: true,
  },
  {
    id: 8,
    label: 'Join time',
    field_name: 'joined_at',
    source_field: 'joined_at',
    showColumn: true,
  },
  {
    id: 9,
    label: 'Canceled At',
    field_name: 'canceled_at',
    source_field: 'canceled_at',
    showColumn: true,
  },
  {
    id: 10,
    label: 'Level of class',
    field_name: 'level',
    source_field: 'level',
    showColumn: true,
  },
  {
    id: 11,
    label: 'Class name',
    field_name: 'class_name',
    source_field: 'class_name',
    showColumn: true,
  },
  {
    id: 12,
    label: 'Lesson',
    field_name: 'lesson',
    source_field: 'lesson',
    showColumn: true,
  },
  {
    id: 13,
    label: 'Teacher name',
    field_name: 'teacher_name',
    source_field: 'teacher_name',
    showColumn: true,
  },
  {
    id: 14,
    label: 'Zoom entry time',
    field_name: 'zoom_joined_at',
    source_field: 'zoom_joined_at',
    showColumn: true,
  },
  {
    id: 15,
    label: 'Zoom exit time',
    field_name: 'zoom_left_at',
    source_field: 'zoom_left_at',
    showColumn: true,
  },
  {
    id: 16,
    label: 'Minutes connected',
    field_name: 'connected_minutes',
    source_field: 'connected_minutes',
    showColumn: true,
  },
  {
    id: 17,
    label: 'Connections',
    field_name: 'connection_count',
    source_field: 'connection_count',
    showColumn: true,
  },
];
